import { useMemo, useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import { useLocation } from 'react-router'

import { Currency } from '@/constants/currency'
import { BusinessRoute } from '@/constants/paths'
import { ProgressButton } from '@/shared/components'
import { FullScreen } from '@/shared/ui'

import {
  AccountInfoStep,
  SelectCurrencyStep,
} from './components/CreateAccountSteps'

enum Step {
  AccountInfo = 'accountInfo',
  SelectCurrency = 'selectCurrency',
  KYB = 'KYB',
}

type State = { type: Step.SelectCurrency } | { type: Step.AccountInfo }

export const CreateAccount = () => {
  const location = useLocation()
  const [currency, setCurrency] = useState<Currency>()

  const [activeStep, setActiveStep] = useState<State>({
    type: Step.AccountInfo,
  })

  const progressByStep = useMemo(() => {
    switch (activeStep.type) {
      case Step.AccountInfo:
        return 25
      case Step.SelectCurrency:
        return 50
    }
  }, [activeStep.type])

  return (
    <FullScreen>
      <ProgressButton
        progress={progressByStep}
        to={location.state?.from ?? BusinessRoute.Accounts}
      />

      <AnimatePresence mode="wait">
        {activeStep.type === Step.SelectCurrency && (
          <SelectCurrencyStep
            onContinue={(currency) => {
              setCurrency(currency)

              setActiveStep({ type: Step.AccountInfo })
            }}
          />
        )}

        {activeStep.type === Step.AccountInfo && (
          <AccountInfoStep
            // onBack={() => setActiveStep({ type: Step.SelectCurrency })}
            currency={currency}
          />
        )}
      </AnimatePresence>
    </FullScreen>
  )
}
